import React, { useRef, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { ReactComponent as Info } from "../../../assets/icons/info.svg";

const Bubble = styled.div`
  position: absolute;
  transform: translateX(-110%) translateY(-13px);
  color: #fff;
  padding: 6px 10px;
  border-radius: 5px;
  background-color: #000;
  border: 1px solid #a39e9d;
  font-size: 12px;
  white-space: nowrap;
  z-index: 9999;
`;

const InfoIcon = styled.div`
  width: 16px;
  height: 16px;
  background-color: gray;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
`;

const InfoBubbleStyle: React.CSSProperties = {
  width: "14px",
  height: "14px",
  fill: "white",
  stroke: "white",
  cursor: "pointer",
};

interface InfoBubbleProps {
  children?: React.ReactNode;
  top?: string;
}

export const InfoBubble: React.FC<InfoBubbleProps> = ({
  children,
  top = "-3px",
}) => {
  const iconRef = useRef<SVGSVGElement | null>(null);
  const [visible, setVisible] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (iconRef.current && visible) {
      const rect = iconRef.current.getBoundingClientRect();
      setCoords({
        top: rect.top + window.scrollY,
        left: rect.left + window.scrollX,
      });
    }
  }, [visible]);

  return (
    <>
      <div
        style={{
          top: top,
          position: "relative",
        }}
      >
        <Info
          ref={iconRef}
          onMouseEnter={() => setVisible(true)}
          onMouseLeave={() => setVisible(false)}
          style={{
            ...InfoBubbleStyle,
          }}
        />
      </div>

      {visible &&
        ReactDOM.createPortal(
          <Bubble style={{ top: coords.top, left: coords.left }}>
            {children}
          </Bubble>,
          document.getElementById("portal-root")!,
        )}
    </>
  );
};
